export enum HuginnErrorCodesEnum {
    None = -1,
    //Common
    Unknown = 0,
    Validation = 1,
    InsufficientPermissions = 2,
    Unauthorized = 3,
    WrongHeader = 4,
    BearerTokenIsExpected = 5,
    InvalidToken = 6,
    InvalidProduct = 7,
    NotSupportedFormat = 8,
    UnknownJobName = 9,
    NoFileReceived = 10,
    FileNameIsIncorrect = 11,

    WordNotFound = 25,
    BaseWordNotFound = 26,

    PictureNotFound = 50,

    LanguageNotFound = 75,

    DestinationLanguagesNotFound = 76,

    UseOfLanguageIsNotPermitted = 77,

    //Dictionaries
    DictionaryNotFound = 100,

    PictureDictionaryNotFound = 101,

    UseOfPictureDictionaryIsNotPermitted = 102,

    UseOfExplanationDictionaryIsNotPermitted = 103,

    UseOfTranslationDictionaryIsNotPermitted = 104,

    //Dictionary entries
    ExplanationNotFound = 125,

    TranslationsNotFound = 126,

    //Verbs
    VerbNotFound = 150,

    ConjugationsNotFound = 151,

    //Language
    LanguageCodeIsNotSupported = 175,

    //KESPDFConversion
    KESInvalidPassword = 200,
    IKESExpired = 201,
    KESPDFFileNotFound = 202,
    UnsupportedKESConversionFormat = 203,
    DediconUnableToExtractKESFile = 204,
    DediconUnableToExtractDediconDetails = 205,
    UnknownDediconServerReply = 206,
    DediconDocumentIsNotValid = 207,
    DediconDocumentIsMachineLimitHasReached = 208,
    DediconAccessTokenIsUnknown = 209,
    DediconBookCannotBeValidated = 210,
    DediconBookIsExpired = 211,
    DediconBookIsCorrupted = 212,
    UnableToSaveDediconFile = 213,
    FailedToCreateXODFile = 214,

    //Homophone
    HomophonesNotFound = 225,

    //OCR
    NoRecognitionResult = 250,
    RecognizedPdfNotFound = 251,
    IncorrectRotation = 252,
    OCRInputFileNotFound = 253,
    OCRResultFileNotFound = 254,

    QueueItemNotFound = 275,

    //SpellCheck
    SpellCheckLanguageIsNotSupported = 300,
    SpellCheckInputSentenceIsTooLong = 301,
    OnlyOneWordIsAllowed = 302,
    WordIsTooLong = 303,

    //RTFHTMLConversion
    RTFHTMLFileNotFound = 325,

    //Misc
    LookupWordsNotPermitted = 10000,
    PictureDictionariesNotPermitted = 10001,
    ExplanationDictionariesNotPermitted = 10002,
    TranslationDictionariesNotPermitted = 10003,
    HomophonesNotPermitted = 10004,
    SampleSentencesNotPermitted = 10005,
    RelatedWordsNotPermitted = 10006,
    ConjugationsNotPermitted = 10007,
    SpellCheckNotPermitted = 10008,
    KESPDFConversionNotPermitted = 10009,
    OCRNotPermitted = 10010,
    WordPredictionNotPermitted = 10011,
    RTFHTMLConversionNotPermitted = 10012
}
